import { render, staticRenderFns } from "./LottieCheck.vue?vue&type=template&id=b51e06dc&scoped=true&"
import script from "./LottieCheck.vue?vue&type=script&lang=js&"
export * from "./LottieCheck.vue?vue&type=script&lang=js&"
import style0 from "./LottieCheck.vue?vue&type=style&index=0&id=b51e06dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51e06dc",
  null
  
)

component.options.__file = "LottieCheck.vue"
export default component.exports